import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PartnerBonusType } from 'src/app/interfaces/partner-bonus';
import { PartnerOption } from 'src/app/interfaces/partners';
import { ConfigService } from 'src/app/providers/config/config.service';
import { PartnerBonusService } from 'src/app/providers/partner-bonus/partner-bonus.service';

@Component({
  selector: 'app-partner-bonus-select',
  templateUrl: './partner-bonus-select.component.html',
  styleUrls: ['./partner-bonus-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerBonusSelectComponent implements OnInit, OnDestroy{
  @Input() options: PartnerOption[] = [];
  @Input() bonusType: PartnerBonusType = PartnerBonusType.BONUS_REGISTRATION;
  @Output() selectionChange = new EventEmitter<any>();
  @Input() offerText: {
    title: string,
    description: string
  }

  subscription = new Subscription();
  dropdownOpen = false;
  selectedOption: PartnerOption | null = null;
  selectedOptionIndex: number = 0;
  animationClass = '';

  constructor(private eRef: ElementRef, public config: ConfigService, private partnerBonusService: PartnerBonusService){}

  ngOnInit(): void {
    this.subscription.add(this.partnerBonusService.partnerBonusesLoaded.subscribe((loaded) => {
      if(loaded){
        this.selectOption(0);
        this.confirmSelection();
      }
    }));
  }

  toggleDropdown() {
    if (!this.dropdownOpen) {
      this.animationClass = 'open';
      this.dropdownOpen = true;
    } else {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.animationClass = 'close';
    setTimeout(() => {
      this.dropdownOpen = false;
    }, 300); // Wait for animation to complete before hiding
  }

  partnerImageUrl(str: string){
    return `assets/images/${str.toLowerCase().replace(/\s/g,'')}.jpg`;
  }

  selectOption(index: number) {
    this.selectedOption = this.options[index];
    this.selectedOptionIndex = index;
    this.confirmSelection();
  }

  confirmSelection() {
    switch (this.bonusType) {
      case PartnerBonusType.BONUS_REGISTRATION:
        this.partnerBonusService.selectedRegistrationBonus.next(this.selectedOptionIndex);
        break;
      case PartnerBonusType.BONUS_DEPOSIT:
        this.partnerBonusService.selectedDepositBonus.next(this.selectedOptionIndex);
        break;
      default:
        break;
    }
    if(this.selectedOption){
      this.selectionChange.emit(this.selectedOption.value);
    }
    this.dropdownOpen = false;
  }

  // Detect clicks outside the dropdown
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
